export const cityIndia = {
  "Andaman and Nicobar Islands": [{ name: "Port Blair" }],
  Haryana: [
    { name: "Faridabad" },
    { name: "Gurgaon" },
    { name: "Hisar" },
    { name: "Rohtak" },
    { name: "Panipat" },
    { name: "Karnal" },
    { name: "Sonipat" },
    { name: "Yamunanagar" },
    { name: "Panchkula" },
    { name: "Bhiwani" },
    { name: "Bahadurgarh" },
    { name: "Jind" },
    { name: "Sirsa" },
    { name: "Thanesar" },
    { name: "Kaithal" },
    { name: "Palwal" },
    { name: "Rewari" },
    { name: "Hansi" },
    { name: "Narnaul" },
    { name: "Fatehabad" },
    { name: "Gohana" },
    { name: "Tohana" },
    { name: "Narwana" },
    { name: "Mandi Dabwali" },
    { name: "Charkhi Dadri" },
    { name: "Shahbad" },
    { name: "Pehowa" },
    { name: "Samalkha" },
    { name: "Pinjore" },
    { name: "Ladwa" },
    { name: "Sohna" },
    { name: "Safidon" },
    { name: "Taraori" },
    { name: "Mahendragarh" },
    { name: "Ratia" },
    { name: "Rania" },
    { name: "Sarsod" },
    { name: "Chandigarh" },
  ],
  "Tamil Nadu": [
    { name: "Chennai" },
    { name: "Coimbatore" },
    { name: "Madurai" },
    { name: "Tiruchirappalli" },
    { name: "Salem" },
    { name: "Tirunelveli" },
    { name: "Tiruppur" },
    { name: "Ranipet" },
    { name: "Nagercoil" },
    { name: "Thanjavur" },
    { name: "Vellore" },
    { name: "Kancheepuram" },
    { name: "Erode" },
    { name: "Tiruvannamalai" },
    { name: "Pollachi" },
    { name: "Rajapalayam" },
    { name: "Sivakasi" },
    { name: "Pudukkottai" },
    { name: "Neyveli (TS)" },
    { name: "Nagapattinam" },
    { name: "Viluppuram" },
    { name: "Tiruchengode" },
    { name: "Vaniyambadi" },
    { name: "Theni Allinagaram" },
    { name: "Udhagamandalam" },
    { name: "Aruppukkottai" },
    { name: "Paramakudi" },
    { name: "Arakkonam" },
    { name: "Virudhachalam" },
    { name: "Srivilliputhur" },
    { name: "Tindivanam" },
    { name: "Virudhunagar" },
    { name: "Karur" },
    { name: "Valparai" },
    { name: "Sankarankovil" },
    { name: "Tenkasi" },
    { name: "Palani" },
    { name: "Pattukkottai" },
    { name: "Tirupathur" },
    { name: "Ramanathapuram" },
    { name: "Udumalaipettai" },
    { name: "Gobichettipalayam" },
    { name: "Thiruvarur" },
    { name: "Thiruvallur" },
    { name: "Panruti" },
    { name: "Namakkal" },
    { name: "Thirumangalam" },
    { name: "Vikramasingapuram" },
    { name: "Nellikuppam" },
    { name: "Rasipuram" },
    { name: "Tiruttani" },
    { name: "Nandivaram-Guduvancheri" },
    { name: "Periyakulam" },
    { name: "Pernampattu" },
    { name: "Vellakoil" },
    { name: "Sivaganga" },
    { name: "Vadalur" },
    { name: "Rameshwaram" },
    { name: "Tiruvethipuram" },
    { name: "Perambalur" },
    { name: "Usilampatti" },
    { name: "Vedaranyam" },
    { name: "Sathyamangalam" },
    { name: "Puliyankudi" },
    { name: "Nanjikottai" },
    { name: "Thuraiyur" },
    { name: "Sirkali" },
    { name: "Tiruchendur" },
    { name: "Periyasemur" },
    { name: "Sattur" },
    { name: "Vandavasi" },
    { name: "Tharamangalam" },
    { name: "Tirukkoyilur" },
    { name: "Oddanchatram" },
    { name: "Palladam" },
    { name: "Vadakkuvalliyur" },
    { name: "Tirukalukundram" },
    { name: "Uthamapalayam" },
    { name: "Surandai" },
    { name: "Sankari" },
    { name: "Shenkottai" },
    { name: "Vadipatti" },
    { name: "Sholingur" },
    { name: "Tirupathur" },
    { name: "Manachanallur" },
    { name: "Viswanatham" },
    { name: "Polur" },
    { name: "Panagudi" },
    { name: "Uthiramerur" },
    { name: "Thiruthuraipoondi" },
    { name: "Pallapatti" },
    { name: "Ponneri" },
    { name: "Lalgudi" },
    { name: "Natham" },
    { name: "Unnamalaikadai" },
    { name: "P.N.Patti" },
    { name: "Tharangambadi" },
    { name: "Tittakudi" },
    { name: "Pacode" },
    { name: "O' Valley" },
    { name: "Suriyampalayam" },
    { name: "Sholavandan" },
    { name: "Thammampatti" },
    { name: "Namagiripettai" },
    { name: "Peravurani" },
    { name: "Parangipettai" },
    { name: "Pudupattinam" },
    { name: "Pallikonda" },
    { name: "Sivagiri" },
    { name: "Punjaipugalur" },
    { name: "Padmanabhapuram" },
    { name: "Thirupuvanam" },
  ],
  "Madhya Pradesh": [
    { name: "Indore" },
    { name: "Bhopal" },
    { name: "Jabalpur" },
    { name: "Gwalior" },
    { name: "Ujjain" },
    { name: "Sagar" },
    { name: "Ratlam" },
    { name: "Satna" },
    { name: "Murwara (Katni)" },
    { name: "Morena" },
    { name: "Singrauli" },
    { name: "Rewa" },
    { name: "Vidisha" },
    { name: "Ganjbasoda" },
    { name: "Shivpuri" },
    { name: "Mandsaur" },
    { name: "Neemuch" },
    { name: "Nagda" },
    { name: "Itarsi" },
    { name: "Sarni" },
    { name: "Sehore" },
    { name: "Mhow Cantonment" },
    { name: "Seoni" },
    { name: "Balaghat" },
    { name: "Ashok Nagar" },
    { name: "Tikamgarh" },
    { name: "Shahdol" },
    { name: "Pithampur" },
    { name: "Alirajpur" },
    { name: "Mandla" },
    { name: "Sheopur" },
    { name: "Shajapur" },
    { name: "Panna" },
    { name: "Raghogarh-Vijaypur" },
    { name: "Sendhwa" },
    { name: "Sidhi" },
    { name: "Pipariya" },
    { name: "Shujalpur" },
    { name: "Sironj" },
    { name: "Pandhurna" },
    { name: "Nowgong" },
    { name: "Mandideep" },
    { name: "Sihora" },
    { name: "Raisen" },
    { name: "Lahar" },
    { name: "Maihar" },
    { name: "Sanawad" },
    { name: "Sabalgarh" },
    { name: "Umaria" },
    { name: "Porsa" },
    { name: "Narsinghgarh" },
    { name: "Malaj Khand" },
    { name: "Sarangpur" },
    { name: "Mundi" },
    { name: "Nepanagar" },
    { name: "Pasan" },
    { name: "Mahidpur" },
    { name: "Seoni-Malwa" },
    { name: "Rehli" },
    { name: "Manawar" },
    { name: "Rahatgarh" },
    { name: "Panagar" },
    { name: "Wara Seoni" },
    { name: "Tarana" },
    { name: "Sausar" },
    { name: "Rajgarh" },
    { name: "Niwari" },
    { name: "Mauganj" },
    { name: "Manasa" },
    { name: "Nainpur" },
    { name: "Prithvipur" },
    { name: "Sohagpur" },
    { name: "Nowrozabad (Khodargama)" },
    { name: "Shamgarh" },
    { name: "Maharajpur" },
    { name: "Multai" },
    { name: "Pali" },
    { name: "Pachore" },
    { name: "Rau" },
    { name: "Mhowgaon" },
    { name: "Vijaypur" },
    { name: "Narsinghgarh" },
  ],
  Jharkhand: [
    { name: "Dhanbad" },
    { name: "Ranchi" },
    { name: "Jamshedpur" },
    { name: "Bokaro Steel City" },
    { name: "Deoghar" },
    { name: "Phusro" },
    { name: "Adityapur" },
    { name: "Hazaribag" },
    { name: "Giridih" },
    { name: "Ramgarh" },
    { name: "Jhumri Tilaiya" },
    { name: "Saunda" },
    { name: "Sahibganj" },
    { name: "Medininagar (Daltonganj)" },
    { name: "Chaibasa" },
    { name: "Chatra" },
    { name: "Gumia" },
    { name: "Dumka" },
    { name: "Madhupur" },
    { name: "Chirkunda" },
    { name: "Pakaur" },
    { name: "Simdega" },
    { name: "Musabani" },
    { name: "Mihijam" },
    { name: "Patratu" },
    { name: "Lohardaga" },
    { name: "Tenu dam-cum-Kathhara" },
  ],
  Mizoram: [{ name: "Aizawl" }, { name: "Lunglei" }, { name: "Saiha" }],
  Nagaland: [
    { name: "Dimapur" },
    { name: "Kohima" },
    { name: "Zunheboto" },
    { name: "Tuensang" },
    { name: "Wokha" },
    { name: "Mokokchung" },
  ],
  "Himachal Pradesh": [
    { name: "Shimla" },
    { name: "Mandi" },
    { name: "Solan" },
    { name: "Nahan" },
    { name: "Sundarnagar" },
    { name: "Palampur" },
    { name: "Kullu" },
  ],
  Tripura: [
    { name: "Agartala" },
    { name: "Udaipur" },
    { name: "Dharmanagar" },
    { name: "Pratapgarh" },
    { name: "Kailasahar" },
    { name: "Belonia" },
    { name: "Khowai" },
  ],
  "Andhra Pradesh": [
    { name: "Visakhapatnam" },
    { name: "Vijayawada" },
    { name: "Guntur" },
    { name: "Nellore" },
    { name: "Kurnool" },
    { name: "Rajahmundry" },
    { name: "Kakinada" },
    { name: "Tirupati" },
    { name: "Anantapur" },
    { name: "Kadapa" },
    { name: "Vizianagaram" },
    { name: "Eluru" },
    { name: "Ongole" },
    { name: "Nandyal" },
    { name: "Machilipatnam" },
    { name: "Adoni" },
    { name: "Tenali" },
    { name: "Chittoor" },
    { name: "Hindupur" },
    { name: "Proddatur" },
    { name: "Bhimavaram" },
    { name: "Madanapalle" },
    { name: "Guntakal" },
    { name: "Dharmavaram" },
    { name: "Gudivada" },
    { name: "Srikakulam" },
    { name: "Narasaraopet" },
    { name: "Rajampet" },
    { name: "Tadpatri" },
    { name: "Tadepalligudem" },
    { name: "Chilakaluripet" },
    { name: "Yemmiganur" },
    { name: "Kadiri" },
    { name: "Chirala" },
    { name: "Anakapalle" },
    { name: "Kavali" },
    { name: "Palacole" },
    { name: "Sullurpeta" },
    { name: "Tanuku" },
    { name: "Rayachoti" },
    { name: "Srikalahasti" },
    { name: "Bapatla" },
    { name: "Naidupet" },
    { name: "Nagari" },
    { name: "Gudur" },
    { name: "Vinukonda" },
    { name: "Narasapuram" },
    { name: "Nuzvid" },
    { name: "Markapur" },
    { name: "Ponnur" },
    { name: "Kandukur" },
    { name: "Bobbili" },
    { name: "Rayadurg" },
    { name: "Samalkot" },
    { name: "Jaggaiahpet" },
    { name: "Tuni" },
    { name: "Amalapuram" },
    { name: "Bheemunipatnam" },
    { name: "Venkatagiri" },
    { name: "Sattenapalle" },
    { name: "Pithapuram" },
    { name: "Palasa Kasibugga" },
    { name: "Parvathipuram" },
    { name: "Macherla" },
    { name: "Gooty" },
    { name: "Salur" },
    { name: "Mandapeta" },
    { name: "Jammalamadugu" },
    { name: "Peddapuram" },
    { name: "Punganur" },
    { name: "Nidadavole" },
    { name: "Repalle" },
    { name: "Ramachandrapuram" },
    { name: "Kovvur" },
    { name: "Tiruvuru" },
    { name: "Uravakonda" },
    { name: "Narsipatnam" },
    { name: "Yerraguntla" },
    { name: "Pedana" },
    { name: "Puttur" },
    { name: "Renigunta" },
    { name: "Rajam" },
    { name: "Srisailam Project (Right Flank Colony) Township" },
  ],
  Punjab: [
    { name: "Ludhiana" },
    { name: "Patiala" },
    { name: "Amritsar" },
    { name: "Jalandhar" },
    { name: "Bathinda" },
    { name: "Pathankot" },
    { name: "Hoshiarpur" },
    { name: "Batala" },
    { name: "Moga" },
    { name: "Malerkotla" },
    { name: "Khanna" },
    { name: "Mohali" },
    { name: "Barnala" },
    { name: "Firozpur" },
    { name: "Phagwara" },
    { name: "Kapurthala" },
    { name: "Zirakpur" },
    { name: "Kot Kapura" },
    { name: "Faridkot" },
    { name: "Muktsar" },
    { name: "Rajpura" },
    { name: "Sangrur" },
    { name: "Fazilka" },
    { name: "Gurdaspur" },
    { name: "Kharar" },
    { name: "Gobindgarh" },
    { name: "Mansa" },
    { name: "Malout" },
    { name: "Nabha" },
    { name: "Tarn Taran" },
    { name: "Jagraon" },
    { name: "Sunam" },
    { name: "Dhuri" },
    { name: "Firozpur Cantt." },
    { name: "Sirhind Fatehgarh Sahib" },
    { name: "Rupnagar" },
    { name: "Jalandhar Cantt." },
    { name: "Samana" },
    { name: "Nawanshahr" },
    { name: "Rampura Phul" },
    { name: "Nangal" },
    { name: "Nakodar" },
    { name: "Zira" },
    { name: "Patti" },
    { name: "Raikot" },
    { name: "Longowal" },
    { name: "Urmar Tanda" },
    { name: "Morinda, India" },
    { name: "Phillaur" },
    { name: "Pattran" },
    { name: "Qadian" },
    { name: "Sujanpur" },
    { name: "Mukerian" },
    { name: "Talwara" },
    { name: "Chandigarh" },
  ],
  Chandigarh: [{ name: "Chandigarh" }],
  Rajasthan: [
    { name: "Jaipur" },
    { name: "Jodhpur" },
    { name: "Bikaner" },
    { name: "Udaipur" },
    { name: "Ajmer" },
    { name: "Bhilwara" },
    { name: "Alwar" },
    { name: "Bharatpur" },
    { name: "Pali" },
    { name: "Barmer" },
    { name: "Sikar" },
    { name: "Tonk" },
    { name: "Sadulpur" },
    { name: "Sawai Madhopur" },
    { name: "Nagaur" },
    { name: "Makrana" },
    { name: "Sujangarh" },
    { name: "Sardarshahar" },
    { name: "Ladnu" },
    { name: "Ratangarh" },
    { name: "Nokha" },
    { name: "Nimbahera" },
    { name: "Suratgarh" },
    { name: "Rajsamand" },
    { name: "Lachhmangarh" },
    { name: "Rajgarh (Churu)" },
    { name: "Nasirabad" },
    { name: "Nohar" },
    { name: "Phalodi" },
    { name: "Nathdwara" },
    { name: "Pilani" },
    { name: "Merta City" },
    { name: "Sojat" },
    { name: "Neem-Ka-Thana" },
    { name: "Sirohi" },
    { name: "Pratapgarh" },
    { name: "Rawatbhata" },
    { name: "Sangaria" },
    { name: "Lalsot" },
    { name: "Pilibanga" },
    { name: "Pipar City" },
    { name: "Taranagar" },
    { name: "Vijainagar, Ajmer" },
    { name: "Sumerpur" },
    { name: "Sagwara" },
    { name: "Ramganj Mandi" },
    { name: "Lakheri" },
    { name: "Udaipurwati" },
    { name: "Losal" },
    { name: "Sri Madhopur" },
    { name: "Ramngarh" },
    { name: "Rawatsar" },
    { name: "Rajakhera" },
    { name: "Shahpura" },
    { name: "Shahpura" },
    { name: "Raisinghnagar" },
    { name: "Malpura" },
    { name: "Nadbai" },
    { name: "Sanchore" },
    { name: "Nagar" },
    { name: "Rajgarh (Alwar)" },
    { name: "Sheoganj" },
    { name: "Sadri" },
    { name: "Todaraisingh" },
    { name: "Todabhim" },
    { name: "Reengus" },
    { name: "Rajaldesar" },
    { name: "Sadulshahar" },
    { name: "Sambhar" },
    { name: "Prantij" },
    { name: "Mount Abu" },
    { name: "Mangrol" },
    { name: "Phulera" },
    { name: "Mandawa" },
    { name: "Pindwara" },
    { name: "Mandalgarh" },
    { name: "Takhatgarh" },
  ],
  Assam: [
    { name: "Guwahati" },
    { name: "Silchar" },
    { name: "Dibrugarh" },
    { name: "Nagaon" },
    { name: "Tinsukia" },
    { name: "Jorhat" },
    { name: "Bongaigaon City" },
    { name: "Dhubri" },
    { name: "Diphu" },
    { name: "North Lakhimpur" },
    { name: "Tezpur" },
    { name: "Karimganj" },
    { name: "Sibsagar" },
    { name: "Goalpara" },
    { name: "Barpeta" },
    { name: "Lanka" },
    { name: "Lumding" },
    { name: "Mankachar" },
    { name: "Nalbari" },
    { name: "Rangia" },
    { name: "Margherita" },
    { name: "Mangaldoi" },
    { name: "Silapathar" },
    { name: "Mariani" },
    { name: "Marigaon" },
  ],
  Odisha: [
    { name: "Bhubaneswar" },
    { name: "Cuttack" },
    { name: "Raurkela" },
    { name: "Brahmapur" },
    { name: "Sambalpur" },
    { name: "Puri" },
    { name: "Baleshwar Town" },
    { name: "Baripada Town" },
    { name: "Bhadrak" },
    { name: "Balangir" },
    { name: "Jharsuguda" },
    { name: "Bargarh" },
    { name: "Paradip" },
    { name: "Bhawanipatna" },
    { name: "Dhenkanal" },
    { name: "Barbil" },
    { name: "Kendujhar" },
    { name: "Sunabeda" },
    { name: "Rayagada" },
    { name: "Jatani" },
    { name: "Byasanagar" },
    { name: "Kendrapara" },
    { name: "Rajagangapur" },
    { name: "Parlakhemundi" },
    { name: "Talcher" },
    { name: "Sundargarh" },
    { name: "Phulabani" },
    { name: "Pattamundai" },
    { name: "Titlagarh" },
    { name: "Nabarangapur" },
    { name: "Soro" },
    { name: "Malkangiri" },
    { name: "Rairangpur" },
    { name: "Tarbha" },
  ],
  Chhattisgarh: [
    { name: "Raipur" },
    { name: "Bhilai Nagar" },
    { name: "Korba" },
    { name: "Bilaspur" },
    { name: "Durg" },
    { name: "Rajnandgaon" },
    { name: "Jagdalpur" },
    { name: "Raigarh" },
    { name: "Ambikapur" },
    { name: "Mahasamund" },
    { name: "Dhamtari" },
    { name: "Chirmiri" },
    { name: "Bhatapara" },
    { name: "Dalli-Rajhara" },
    { name: "Naila Janjgir" },
    { name: "Tilda Newra" },
    { name: "Mungeli" },
    { name: "Manendragarh" },
    { name: "Sakti" },
  ],
  "Jammu and Kashmir": [
    { name: "Srinagar" },
    { name: "Jammu" },
    { name: "Baramula" },
    { name: "Anantnag" },
    { name: "Sopore" },
    { name: "KathUrban Agglomeration" },
    { name: "Rajauri" },
    { name: "Punch" },
    { name: "Udhampur" },
  ],
  Karnataka: [
    { name: "Bengaluru" },
    { name: "Hubli-Dharwad" },
    { name: "Belagavi" },
    { name: "Mangaluru" },
    { name: "Davanagere" },
    { name: "Ballari" },
    { name: "Mysore" },
    { name: "Tumkur" },
    { name: "Shivamogga" },
    { name: "Raayachuru" },
    { name: "Robertson Pet" },
    { name: "Kolar" },
    { name: "Mandya" },
    { name: "Udupi" },
    { name: "Chikkamagaluru" },
    { name: "Karwar" },
    { name: "Ranebennuru" },
    { name: "Ramanagaram" },
    { name: "Gokak" },
    { name: "Yadgir" },
    { name: "Rabkavi Banhatti" },
    { name: "Shahabad" },
    { name: "Sirsi" },
    { name: "Sindhnur" },
    { name: "Tiptur" },
    { name: "Arsikere" },
    { name: "Nanjangud" },
    { name: "Sagara" },
    { name: "Sira" },
    { name: "Puttur" },
    { name: "Athni" },
    { name: "Mulbagal" },
    { name: "Surapura" },
    { name: "Siruguppa" },
    { name: "Mudhol" },
    { name: "Sidlaghatta" },
    { name: "Shahpur" },
    { name: "Saundatti-Yellamma" },
    { name: "Wadi" },
    { name: "Manvi" },
    { name: "Nelamangala" },
    { name: "Lakshmeshwar" },
    { name: "Ramdurg" },
    { name: "Nargund" },
    { name: "Tarikere" },
    { name: "Malavalli" },
    { name: "Savanur" },
    { name: "Lingsugur" },
    { name: "Vijayapura" },
    { name: "Sankeshwara" },
    { name: "Madikeri" },
    { name: "Talikota" },
    { name: "Sedam" },
    { name: "Shikaripur" },
    { name: "Mahalingapura" },
    { name: "Mudalagi" },
    { name: "Muddebihal" },
    { name: "Pavagada" },
    { name: "Malur" },
    { name: "Sindhagi" },
    { name: "Sanduru" },
    { name: "Afzalpur" },
    { name: "Maddur" },
    { name: "Madhugiri" },
    { name: "Tekkalakote" },
    { name: "Terdal" },
    { name: "Mudabidri" },
    { name: "Magadi" },
    { name: "Navalgund" },
    { name: "Shiggaon" },
    { name: "Shrirangapattana" },
    { name: "Sindagi" },
    { name: "Sakaleshapura" },
    { name: "Srinivaspur" },
    { name: "Ron" },
    { name: "Mundargi" },
    { name: "Sadalagi" },
    { name: "Piriyapatna" },
    { name: "Adyar" },
  ],
  Manipur: [{ name: "Imphal" }, { name: "Thoubal" }, { name: "Lilong" }, { name: "Mayang Imphal" }],
  Kerala: [
    { name: "Thiruvananthapuram" },
    { name: "Kochi" },
    { name: "Kozhikode" },
    { name: "Kollam" },
    { name: "Thrissur" },
    { name: "Palakkad" },
    { name: "Alappuzha" },
    { name: "Malappuram" },
    { name: "Ponnani" },
    { name: "Vatakara" },
    { name: "Kanhangad" },
    { name: "Taliparamba" },
    { name: "Koyilandy" },
    { name: "Neyyattinkara" },
    { name: "Kayamkulam" },
    { name: "Nedumangad" },
    { name: "Kannur" },
    { name: "Tirur" },
    { name: "Kottayam" },
    { name: "Kasaragod" },
    { name: "Kunnamkulam" },
    { name: "Ottappalam" },
    { name: "Thiruvalla" },
    { name: "Thodupuzha" },
    { name: "Chalakudy" },
    { name: "Changanassery" },
    { name: "Punalur" },
    { name: "Nilambur" },
    { name: "Cherthala" },
    { name: "Perinthalmanna" },
    { name: "Mattannur" },
    { name: "Shoranur" },
    { name: "Varkala" },
    { name: "Paravoor" },
    { name: "Pathanamthitta" },
    { name: "Peringathur" },
    { name: "Attingal" },
    { name: "Kodungallur" },
    { name: "Pappinisseri" },
    { name: "Chittur-Thathamangalam" },
    { name: "Muvattupuzha" },
    { name: "Adoor" },
    { name: "Mavelikkara" },
    { name: "Mavoor" },
    { name: "Perumbavoor" },
    { name: "Vaikom" },
    { name: "Palai" },
    { name: "Panniyannur" },
    { name: "Guruvayoor" },
    { name: "Puthuppally" },
    { name: "Panamattom" },
  ],
  Delhi: [{ name: "Delhi" }, { name: "New Delhi" }],
  "Dadra and Nagar Haveli and Daman and Diu": [{ name: "Silvassa" }],
  Puducherry: [{ name: "Pondicherry" }, { name: "Karaikal" }, { name: "Yanam" }, { name: "Mahe" }],
  Uttarakhand: [
    { name: "Dehradun" },
    { name: "Hardwar" },
    { name: "Haldwani-cum-Kathgodam" },
    { name: "Srinagar" },
    { name: "Kashipur" },
    { name: "Roorkee" },
    { name: "Rudrapur" },
    { name: "Rishikesh" },
    { name: "Ramnagar" },
    { name: "Pithoragarh" },
    { name: "Manglaur" },
    { name: "Nainital" },
    { name: "Mussoorie" },
    { name: "Tehri" },
    { name: "Pauri" },
    { name: "Nagla" },
    { name: "Sitarganj" },
    { name: "Bageshwar" },
  ],
  "Uttar Pradesh": [
    { name: "Lucknow" },
    { name: "Kanpur" },
    { name: "Firozabad" },
    { name: "Agra" },
    { name: "Meerut" },
    { name: "Varanasi" },
    { name: "Allahabad" },
    { name: "Amroha" },
    { name: "Moradabad" },
    { name: "Aligarh" },
    { name: "Saharanpur" },
    { name: "Noida" },
    { name: "Loni" },
    { name: "Jhansi" },
    { name: "Shahjahanpur" },
    { name: "Rampur" },
    { name: "Modinagar" },
    { name: "Hapur" },
    { name: "Etawah" },
    { name: "Sambhal" },
    { name: "Orai" },
    { name: "Bahraich" },
    { name: "Unnao" },
    { name: "Rae Bareli" },
    { name: "Lakhimpur" },
    { name: "Sitapur" },
    { name: "Lalitpur" },
    { name: "Pilibhit" },
    { name: "Chandausi" },
    { name: "Hardoi " },
    { name: "Azamgarh" },
    { name: "Khair" },
    { name: "Sultanpur" },
    { name: "Tanda" },
    { name: "Nagina" },
    { name: "Shamli" },
    { name: "Najibabad" },
    { name: "Shikohabad" },
    { name: "Sikandrabad" },
    { name: "Shahabad, Hardoi" },
    { name: "Pilkhuwa" },
    { name: "Renukoot" },
    { name: "Vrindavan" },
    { name: "Ujhani" },
    { name: "Laharpur" },
    { name: "Tilhar" },
    { name: "Sahaswan" },
    { name: "Rath" },
    { name: "Sherkot" },
    { name: "Kalpi" },
    { name: "Tundla" },
    { name: "Sandila" },
    { name: "Nanpara" },
    { name: "Sardhana" },
    { name: "Nehtaur" },
    { name: "Seohara" },
    { name: "Padrauna" },
    { name: "Mathura" },
    { name: "Thakurdwara" },
    { name: "Nawabganj" },
    { name: "Siana" },
    { name: "Noorpur" },
    { name: "Sikandra Rao" },
    { name: "Puranpur" },
    { name: "Rudauli" },
    { name: "Thana Bhawan" },
    { name: "Palia Kalan" },
    { name: "Zaidpur" },
    { name: "Nautanwa" },
    { name: "Zamania" },
    { name: "Shikarpur, Bulandshahr" },
    { name: "Naugawan Sadat" },
    { name: "Fatehpur Sikri" },
    { name: "Shahabad, Rampur" },
    { name: "Robertsganj" },
    { name: "Utraula" },
    { name: "Sadabad" },
    { name: "Rasra" },
    { name: "Lar" },
    { name: "Lal Gopalganj Nindaura" },
    { name: "Sirsaganj" },
    { name: "Pihani" },
    { name: "Shamsabad, Agra" },
    { name: "Rudrapur" },
    { name: "Soron" },
    { name: "SUrban Agglomerationr" },
    { name: "Samdhan" },
    { name: "Sahjanwa" },
    { name: "Rampur Maniharan" },
    { name: "Sumerpur" },
    { name: "Shahganj" },
    { name: "Tulsipur" },
    { name: "Tirwaganj" },
    { name: "PurqUrban Agglomerationzi" },
    { name: "Shamsabad, Farrukhabad" },
    { name: "Warhapur" },
    { name: "Powayan" },
    { name: "Sandi" },
    { name: "Achhnera" },
    { name: "Naraura" },
    { name: "Nakur" },
    { name: "Sahaspur" },
    { name: "Safipur" },
    { name: "Reoti" },
    { name: "Sikanderpur" },
    { name: "Saidpur" },
    { name: "Sirsi" },
    { name: "Purwa" },
    { name: "Parasi" },
    { name: "Lalganj" },
    { name: "Phulpur" },
    { name: "Shishgarh" },
    { name: "Sahawar" },
    { name: "Samthar" },
    { name: "Pukhrayan" },
    { name: "Obra" },
    { name: "Niwai" },
    { name: "Mirzapur" },
  ],
  Bihar: [
    { name: "Patna" },
    { name: "Gaya" },
    { name: "Bhagalpur" },
    { name: "Muzaffarpur" },
    { name: "Darbhanga" },
    { name: "Arrah" },
    { name: "Begusarai" },
    { name: "Chhapra" },
    { name: "Katihar" },
    { name: "Munger" },
    { name: "Purnia" },
    { name: "Saharsa" },
    { name: "Sasaram" },
    { name: "Hajipur" },
    { name: "Dehri-on-Sone" },
    { name: "Bettiah" },
    { name: "Motihari" },
    { name: "Bagaha" },
    { name: "Siwan" },
    { name: "Kishanganj" },
    { name: "Jamalpur" },
    { name: "Buxar" },
    { name: "Jehanabad" },
    { name: "Aurangabad" },
    { name: "Lakhisarai" },
    { name: "Nawada" },
    { name: "Jamui" },
    { name: "Sitamarhi" },
    { name: "Araria" },
    { name: "Gopalganj" },
    { name: "Madhubani" },
    { name: "Masaurhi" },
    { name: "Samastipur" },
    { name: "Mokameh" },
    { name: "Supaul" },
    { name: "Dumraon" },
    { name: "Arwal" },
    { name: "Forbesganj" },
    { name: "BhabUrban Agglomeration" },
    { name: "Narkatiaganj" },
    { name: "Naugachhia" },
    { name: "Madhepura" },
    { name: "Sheikhpura" },
    { name: "Sultanganj" },
    { name: "Raxaul Bazar" },
    { name: "Ramnagar" },
    { name: "Mahnar Bazar" },
    { name: "Warisaliganj" },
    { name: "Revelganj" },
    { name: "Rajgir" },
    { name: "Sonepur" },
    { name: "Sherghati" },
    { name: "Sugauli" },
    { name: "Makhdumpur" },
    { name: "Maner" },
    { name: "Rosera" },
    { name: "Nokha" },
    { name: "Piro" },
    { name: "Rafiganj" },
    { name: "Marhaura" },
    { name: "Mirganj" },
    { name: "Lalganj" },
    { name: "Murliganj" },
    { name: "Motipur" },
    { name: "Manihari" },
    { name: "Sheohar" },
    { name: "Maharajganj" },
    { name: "Silao" },
    { name: "Barh" },
    { name: "Asarganj" },
  ],
  Gujarat: [
    { name: "Ahmedabad" },
    { name: "Surat" },
    { name: "Vadodara" },
    { name: "Rajkot" },
    { name: "Bhavnagar" },
    { name: "Jamnagar" },
    { name: "Nadiad" },
    { name: "Porbandar" },
    { name: "Anand" },
    { name: "Morvi" },
    { name: "Mahesana" },
    { name: "Bharuch" },
    { name: "Vapi" },
    { name: "Navsari" },
    { name: "Veraval" },
    { name: "Bhuj" },
    { name: "Godhra" },
    { name: "Palanpur" },
    { name: "Valsad" },
    { name: "Patan" },
    { name: "Deesa" },
    { name: "Amreli" },
    { name: "Anjar" },
    { name: "Dhoraji" },
    { name: "Khambhat" },
    { name: "Mahuva" },
    { name: "Keshod" },
    { name: "Wadhwan" },
    { name: "Ankleshwar" },
    { name: "Savarkundla" },
    { name: "Kadi" },
    { name: "Visnagar" },
    { name: "Upleta" },
    { name: "Una" },
    { name: "Sidhpur" },
    { name: "Unjha" },
    { name: "Mangrol" },
    { name: "Viramgam" },
    { name: "Modasa" },
    { name: "Palitana" },
    { name: "Petlad" },
    { name: "Kapadvanj" },
    { name: "Sihor" },
    { name: "Wankaner" },
    { name: "Limbdi" },
    { name: "Mandvi" },
    { name: "Thangadh" },
    { name: "Vyara" },
    { name: "Padra" },
    { name: "Lunawada" },
    { name: "Rajpipla" },
    { name: "Vapi" },
    { name: "Umreth" },
    { name: "Sanand" },
    { name: "Rajula" },
    { name: "Radhanpur" },
    { name: "Mahemdabad" },
    { name: "Ranavav" },
    { name: "Tharad" },
    { name: "Mansa" },
    { name: "Umbergaon" },
    { name: "Talaja" },
    { name: "Vadnagar" },
    { name: "Manavadar" },
    { name: "Salaya" },
    { name: "Vijapur" },
    { name: "Pardi" },
    { name: "Rapar" },
    { name: "Songadh" },
    { name: "Lathi" },
    { name: "Adalaj" },
    { name: "Chhapra" },
    { name: "Gandhinagar" },
  ],
  Telangana: [
    { name: "Hyderabad" },
    { name: "Warangal" },
    { name: "Nizamabad" },
    { name: "Karimnagar" },
    { name: "Ramagundam" },
    { name: "Khammam" },
    { name: "Mahbubnagar" },
    { name: "Mancherial" },
    { name: "Adilabad" },
    { name: "Suryapet" },
    { name: "Jagtial" },
    { name: "Miryalaguda" },
    { name: "Nirmal" },
    { name: "Kamareddy" },
    { name: "Kothagudem" },
    { name: "Bodhan" },
    { name: "Palwancha" },
    { name: "Mandamarri" },
    { name: "Koratla" },
    { name: "Sircilla" },
    { name: "Tandur" },
    { name: "Siddipet" },
    { name: "Wanaparthy" },
    { name: "Kagaznagar" },
    { name: "Gadwal" },
    { name: "Sangareddy" },
    { name: "Bellampalle" },
    { name: "Bhongir" },
    { name: "Vikarabad" },
    { name: "Jangaon" },
    { name: "Bhadrachalam" },
    { name: "Bhainsa" },
    { name: "Farooqnagar" },
    { name: "Medak" },
    { name: "Narayanpet" },
    { name: "Sadasivpet" },
    { name: "Yellandu" },
    { name: "Manuguru" },
    { name: "Kyathampalle" },
    { name: "Nagarkurnool" },
  ],
  Meghalaya: [{ name: "Shillong" }, { name: "Tura" }, { name: "Nongstoin" }],
  "Himachal Praddesh": [{ name: "Manali" }],
  "Arunachal Pradesh": [{ name: "Naharlagun" }, { name: "Pasighat" }],
  Maharashtra: [
    { name: "Mumbai" },
    { name: "Pune" },
    { name: "Nagpur" },
    { name: "Thane" },
    { name: "Nashik" },
    { name: "Kalyan-Dombivali" },
    { name: "Vasai-Virar" },
    { name: "Solapur" },
    { name: "Mira-Bhayandar" },
    { name: "Bhiwandi" },
    { name: "Amravati" },
    { name: "Nanded-Waghala" },
    { name: "Sangli" },
    { name: "Malegaon" },
    { name: "Akola" },
    { name: "Latur" },
    { name: "Dhule" },
    { name: "Ahmednagar" },
    { name: "Ichalkaranji" },
    { name: "Parbhani" },
    { name: "Panvel" },
    { name: "Yavatmal" },
    { name: "Achalpur" },
    { name: "Osmanabad" },
    { name: "Nandurbar" },
    { name: "Satara" },
    { name: "Wardha" },
    { name: "Udgir" },
    { name: "Aurangabad" },
    { name: "Amalner" },
    { name: "Akot" },
    { name: "Pandharpur" },
    { name: "Shrirampur" },
    { name: "Parli" },
    { name: "Washim" },
    { name: "Ambejogai" },
    { name: "Manmad" },
    { name: "Ratnagiri" },
    { name: "Uran Islampur" },
    { name: "Pusad" },
    { name: "Sangamner" },
    { name: "Shirpur-Warwade" },
    { name: "Malkapur" },
    { name: "Wani" },
    { name: "Lonavla" },
    { name: "Talegaon Dabhade" },
    { name: "Anjangaon" },
    { name: "Umred" },
    { name: "Palghar" },
    { name: "Shegaon" },
    { name: "Ozar" },
    { name: "Phaltan" },
    { name: "Yevla" },
    { name: "Shahade" },
    { name: "Vita" },
    { name: "Umarkhed" },
    { name: "Warora" },
    { name: "Pachora" },
    { name: "Tumsar" },
    { name: "Manjlegaon" },
    { name: "Sillod" },
    { name: "Arvi" },
    { name: "Nandura" },
    { name: "Vaijapur" },
    { name: "Wadgaon Road" },
    { name: "Sailu" },
    { name: "Murtijapur" },
    { name: "Tasgaon" },
    { name: "Mehkar" },
    { name: "Yawal" },
    { name: "Pulgaon" },
    { name: "Nilanga" },
    { name: "Wai" },
    { name: "Umarga" },
    { name: "Paithan" },
    { name: "Rahuri" },
    { name: "Nawapur" },
    { name: "Tuljapur" },
    { name: "Morshi" },
    { name: "Purna" },
    { name: "Satana" },
    { name: "Pathri" },
    { name: "Sinnar" },
    { name: "Uchgaon" },
    { name: "Uran" },
    { name: "Pen" },
    { name: "Karjat" },
    { name: "Manwath" },
    { name: "Partur" },
    { name: "Sangole" },
    { name: "Mangrulpir" },
    { name: "Risod" },
    { name: "Shirur" },
    { name: "Savner" },
    { name: "Sasvad" },
    { name: "Pandharkaoda" },
    { name: "Talode" },
    { name: "Shrigonda" },
    { name: "Shirdi" },
    { name: "Raver" },
    { name: "Mukhed" },
    { name: "Rajura" },
    { name: "Vadgaon Kasba" },
    { name: "Tirora" },
    { name: "Mahad" },
    { name: "Lonar" },
    { name: "Sawantwadi" },
    { name: "Pathardi" },
    { name: "Pauni" },
    { name: "Ramtek" },
    { name: "Mul" },
    { name: "Soyagaon" },
    { name: "Mangalvedhe" },
    { name: "Narkhed" },
    { name: "Shendurjana" },
    { name: "Patur" },
    { name: "Mhaswad" },
    { name: "Loha" },
    { name: "Nandgaon" },
    { name: "Warud" },
  ],
  Goa: [{ name: "Marmagao" }, { name: "Panaji" }, { name: "Margao" }, { name: "Mapusa" }],
  "West Bengal": [
    { name: "Kolkata" },
    { name: "Siliguri" },
    { name: "Asansol" },
    { name: "Raghunathganj" },
    { name: "Kharagpur" },
    { name: "Naihati" },
    { name: "English Bazar" },
    { name: "Baharampur" },
    { name: "Hugli-Chinsurah" },
    { name: "Raiganj" },
    { name: "Jalpaiguri" },
    { name: "Santipur" },
    { name: "Balurghat" },
    { name: "Medinipur" },
    { name: "Habra" },
    { name: "Ranaghat" },
    { name: "Bankura" },
    { name: "Nabadwip" },
    { name: "Darjiling" },
    { name: "Purulia" },
    { name: "Arambagh" },
    { name: "Tamluk" },
    { name: "AlipurdUrban Agglomerationr" },
    { name: "Suri" },
    { name: "Jhargram" },
    { name: "Gangarampur" },
    { name: "Rampurhat" },
    { name: "Kalimpong" },
    { name: "Sainthia" },
    { name: "Taki" },
    { name: "Murshidabad" },
    { name: "Memari" },
    { name: "Paschim Punropara" },
    { name: "Tarakeswar" },
    { name: "Sonamukhi" },
    { name: "PandUrban Agglomeration" },
    { name: "Mainaguri" },
    { name: "Malda" },
    { name: "Panchla" },
    { name: "Raghunathpur" },
    { name: "Mathabhanga" },
    { name: "Monoharpur" },
    { name: "Srirampore" },
    { name: "Adra" },
  ],
  Sikkim: [
    { name: "Gangtok" },
    { name: "Namchi" },
    { name: "Geyzing" },
    { name: "Mangan" },
    { name: "Jorethang" },
    { name: "Rangpo" },
    { name: "Singtam" },
    { name: "Pakyong" },
    { name: "Ravangla" },
    { name: "Soreng" },
  ],
  Lakshadweep: [
    { name: "Kavaratti" },
    { name: "Agatti" },
    { name: "Amini" },
    { name: "Andrott" },
    { name: "Kalpeni" },
    { name: "Kadmat" },
    { name: "Minicoy" },
    { name: "Bangaram" },
    { name: "Bitra" },
    { name: "Chetlat" },
    { name: "Kiltan" },
  ],
  Ladakh: [
    { name: "Leh" },
    { name: "Kargil" },
    { name: "Diskit" },
    { name: "Nubra Valley" },
    { name: "Drass" },
    { name: "Hemis" },
    { name: "Lamayuru" },
    { name: "Pangong Tso" },
    { name: "Tso Moriri" },
    { name: "Zanskar" },
    { name: "Alchi" },
    { name: "Likir" },
    { name: "Phugtal" },
    { name: "Turtuk" },
    { name: "Changthang" },
  ],
};
